export default {
    externalLinks: 'external-links',
    announcementBarModel: 'announcement-bar',
    categoryHeroModel: 'category-hero',
    productFooterModel: 'product-footer',
    pageModel: 'page',
    learningCenterPage: 'learning-center-page',
    learningCenterArticlePage: 'learning-center-article-page',
    cartUpsellModel: 'cart-modal-upsell',
    blogArticleModel: 'blog-article',
    navDrawerContent: 'nav-drawer-content',
    modalContent: 'modal-content',
    popoverContent: 'popover-content',
    learningCenterQuestionnaireQuestion: 'learning-center-questionnaire-question',
    learningCenterGoal: 'learning-center-goal',
    learningCenterGoalBenefit: 'learning-center-goal-benefit',
    learningCenterArticle: 'learning-center-article',
    learningCenterArticleTopic: 'learning-center-article-topic',
    learningCenterLevel: 'learning-center-level',
    learningCenterModule: 'learning-center-module',
    learningCenterModuleSummary: 'learning-center-module-summary',
    learningCenterLessonContent: 'learning-center-lesson-content',
    learningCenterLesson: 'learning-center-lesson',
    footer: 'footer',
    header: 'header',
    learningCenterTemplates: 'learning-center-templates',
    learningCenterArticleAuthor: 'learning-center-article-author',
    sitePreferences: 'site-preferences',
    accountFormLabels: 'account-form-labels',
    tpaWelcomeBanner: 'tpa-welcome-banner',
    guestAccessRules: 'guest-access-rules',
    injectableMarketingContent: 'injectable-marketing-content',
    tpaLearningCenterConsent: 'tpa-learning-center-consent',
    customIcons: 'custom-icons',
    signInLinkMessage: 'sign-in-link-message'
}
